import { useOpenCase } from '@/hooks/use-open-case';
import { useOpenTicket } from '@/hooks/use-open-ticket';

export const useScreenPopTriggers = () => {
  useOpenCase();
  useOpenTicket();
};
